import React from 'react';

import ComponentWrapper from '../../common/ComponentWrapper';
import CommonStyles from '../../common/CommonStyles';
import LoaderNew from '../../common/LoaderNew';

import { withStyles } from '@mui/styles';
import { Button, Tabs, Tab } from '@mui/material';

import { getUrlParameter, setUrlParameter } from '../../utils';
import InvalidTripleData from './components/InvalidTripleData';
import InvalidConceptData from './components/InvalidConceptData';

import moment from 'moment';

const styles = {
  ...CommonStyles,
  validator_tabs: {
    minHeight: 0,
    background: '#fff',
    flex: 1,
    display: 'flex',
    '& .MuiTab-root': {
      fontSize: '12px',
      alignItems: 'baseline',
      minWidth: '50px',
      padding: '0px 20px',
      minHeight: '24px',
    },
    '& .MuiTab-wrapper': {
      textTransform: 'none',
      flexDirection: 'row',
      alignItems: 'self-start',
      justifyContent: 'flex-start',
    },
    '& .Mui-selected .MuiTab-wrapper': {
      fontWeight: 550,
    },
    '& .MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
      marginBottom: 0,
    },
    tableLoaderOverlay: {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: '1',
      display: 'flex',
      position: 'absolute',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(255,255,255,0.8)',
    },
  },
};

const TabParams = {
  TRIPLES_BOUNDARIES: 'trpls_boundaries',
  TRIPLES_S_MIN_BOUND: 'trpls_SMinBound',
  TRIPLES_S_MAX_BOUND: 'trpls_SMaxBound',
  TRIPLES_R_S_MAX_BOUND: 'trpls_RSMaxBound',
  TRIPLES_BY_INVERSION: 'trpls_by_inversion',
  TRIPLES_BY_TYPE: 'trpls_valueByType',
  TRIPLES_BLANK_VALUES: 'trpls_blankValue',
  NEED_CONCEPT: 'need_concept',
  NOT_NEED_CONCEPT: 'not_need_concept',
  TRIPLES_UNIQUE_SID: 'trpls_unique_sid',
};

class Validator extends ComponentWrapper {
  state = {
    data: {},
    isDataLoading: false,
    isRunValidation: false,
    currentTab: TabParams.TRIPLES_BOUNDARIES,
  };

  componentDidMount() {
    document.title="Validator | Milkyweb";

    const currentTab = this.getCurrentTypeByTabParam();
    setUrlParameter('tab', currentTab);

    this.setState({ isDataLoading: true }, () => {
      this.get({
        url: `/rest/get_invalid_data`,
        cb: ({ data }) => {
          this.setState({
            data,
            currentTab,
            isDataLoading: false,
          });
        }
      });
    });
  };

  runValidation = () => {
    const { isRunValidation } = this.state;

    if (isRunValidation) return;

    this.setState({ isRunValidation: true }, () => {
      this.postWithData({
        url: `/rest/get_invalid_data`,
        data: {},
        cb: (data) => {
          this.setState({ isRunValidation: false });
        }
      });
    });
  };

  getCurrentTypeByTabParam = () => {
    const tabParam = getUrlParameter('tab');
    return tabParam ? tabParam : TabParams.TRIPLES_BOUNDARIES;
  };

  getNodesNumberOfTrpls = (data) => {
    if (!data) return 0;
    return Object.keys(data).length
  };

  getNodesNumberOfNodes = (data) => {
    let count = 0;
    if (!data) return count;
    for (const pid of Object.keys(data))
      count += data[pid].length;
    return count;
  }

  render() {
    const {
      classes,
    } = this.props;

    const {
      data,
      currentTab,
      isDataLoading,
      isRunValidation,
    } = this.state;

    const {
      need_concept, not_need_concept,
      trpls_boundaries, trpls_SMinBound, trpls_SMaxBound,
      trpls_RSMaxBound, trpls_by_inversion, trpls_valueByType,
      trpls_blankValue, trpls_unique_sid,
    } = data;

    const invalidTrplsData = currentTab === TabParams.TRIPLES_BOUNDARIES
      ? trpls_boundaries
      : currentTab === TabParams.TRIPLES_S_MIN_BOUND
        ? trpls_SMinBound
        : currentTab === TabParams.TRIPLES_S_MAX_BOUND
          ? trpls_SMaxBound
          : currentTab === TabParams.TRIPLES_R_S_MAX_BOUND
            ? trpls_RSMaxBound
            : currentTab === TabParams.TRIPLES_BY_INVERSION
              ? trpls_by_inversion
              : currentTab === TabParams.TRIPLES_BY_TYPE
                ? trpls_valueByType
                : currentTab === TabParams.TRIPLES_BLANK_VALUES
                  ? trpls_blankValue
                  : currentTab === TabParams.TRIPLES_UNIQUE_SID
                    ? trpls_unique_sid
                    : null;

    const dataWithoutTrpls = currentTab === TabParams.TRIPLES_S_MIN_BOUND
      || currentTab === TabParams.TRIPLES_S_MAX_BOUND
      || currentTab === TabParams.TRIPLES_R_S_MAX_BOUND;

    const invalidConceptData = currentTab === TabParams.NEED_CONCEPT
      ? need_concept
      : currentTab === TabParams.NOT_NEED_CONCEPT
        ? not_need_concept
        : null;

    return (
      <div className={`${classes.container} ${classes.mb50}`}>
        <div
          className={`${classes.mb10} ${classes.p5}`}
          style={{ backgroundColor: '#fff' }}
        >
          <Button
            size="small"
            className={`${classes.btn} ${classes.btnNormal}`}
            style={{
              textTransform: 'capitalize',
              width: '120px'
            }}
            onClick={() => {
              this.runValidation();
            }}
          >
            {isRunValidation ? <LoaderNew/> : 'Run validation'}
          </Button>

          <div
            className={`${classes.inlineFlex} ${classes.ml20}`}
          >
            {!isDataLoading ? (
              JSON.stringify(data) === '{}' ? (
                <div>
                  <span>Note:</span>
                  <span style={{ paddingLeft: '5px' }}>Validation was not performed yet</span>
                </div>
              ) : data.last_update ? (
                <div>
                  <span>Last update:</span>
                  <span style={{ paddingLeft: '5px' }}>
                    {moment(data.last_update).format('DD/MM/YYYY HH:mm')}
                  </span>
                </div>
              ) : null)
            : null}
          </div>

        </div>

        <div className={`${classes.tabsContainer} ${classes.mb10}`}>

          <Tabs
            className={classes.validator_tabs}
            value={currentTab}
            onChange={(event, newTab) => {
              setUrlParameter('tab', newTab);
              this.setState({ currentTab: newTab });
            }}
            orientation="vertical"
          >
            <Tab value={TabParams.TRIPLES_BOUNDARIES} label={`Boundaries (${this.getNodesNumberOfTrpls(trpls_boundaries)})`} />
            <Tab value={TabParams.TRIPLES_S_MIN_BOUND} label={`SubjectMinBound (${this.getNodesNumberOfTrpls(trpls_SMinBound)})`} />
            <Tab value={TabParams.TRIPLES_S_MAX_BOUND} label={`SubjectMaxBound (${this.getNodesNumberOfTrpls(trpls_SMaxBound)})`} />
            <Tab value={TabParams.TRIPLES_R_S_MAX_BOUND} label={`RSubjectMaxBound (${this.getNodesNumberOfTrpls(trpls_RSMaxBound)})`} />
            <Tab value={TabParams.TRIPLES_BY_INVERSION} label={`Inversion (${this.getNodesNumberOfTrpls(trpls_by_inversion)})`} />
            <Tab value={TabParams.TRIPLES_BY_TYPE} label={`Trpls type (${this.getNodesNumberOfTrpls(trpls_valueByType)})`} />
            <Tab value={TabParams.TRIPLES_BLANK_VALUES} label={`Empty value (${this.getNodesNumberOfTrpls(trpls_blankValue)})`} />
            <Tab value={TabParams.TRIPLES_UNIQUE_SID} label={`Trpls Uniqueness (${this.getNodesNumberOfNodes(trpls_unique_sid)})`} />
            <Tab value={TabParams.NEED_CONCEPT} label={`Need concept (${this.getNodesNumberOfNodes(need_concept)})`} />
            <Tab value={TabParams.NOT_NEED_CONCEPT} label={`Unnecessary concept (${this.getNodesNumberOfNodes(not_need_concept)})`} />
          </Tabs>
        </div>

        {isDataLoading ? (
          <div className={classes.tableLoaderOverlay}>
            <LoaderNew />
          </div>
        ) : null}

        {invalidTrplsData ? (
          <InvalidTripleData
            trpls={data.trpls}
            nodes={data.nodes}
            classes={classes}
            data={invalidTrplsData}
            dataWithoutTrpls={dataWithoutTrpls}
          />
        ) : invalidConceptData ? (
          <InvalidConceptData
            nodes={data.nodes}
            classes={classes}
            data={invalidConceptData}
          />
        ) : null}

      </div>
    );
  };
}

export default withStyles(styles)(Validator);
